import { Link, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { ContentSubjectDescriptions, MnStateStandardsKey } from 'models/ContentSubject';
import { SubjectBasedValues } from 'models/Lesson';
import React, { FC } from 'react';
import Hr from './Hr';

interface Props {
  title: string;
  subjectLists: SubjectBasedValues;
  showMnStandardsLink?: boolean;
}

const useStyles = makeStyles({
  list: {
    marginBlockStart: 0,
    display: 'inline-block',
    paddingInlineStart: '16px',
    '& > li': {
      display: 'inline-block',
      '&:not(:first-child) > *::before': {
        content: "', '",
        display: 'inline-block',
        marginRight: 4,
      },
    },
  },
});

const SubjectBasedLists: FC<Props> = ({ subjectLists, title, showMnStandardsLink = false }) => {
  const styles = useStyles();

  if (Object.entries(subjectLists).length === 0) {
    return null;
  }

  return (
    <>
      <Typography variant="subtitle1">
        <strong>{title}</strong>
      </Typography>
      <Hr />
      {Object.entries(subjectLists).map(([category, list], index) => (
        <div key={index}>
          <Typography variant="subtitle2" component="span">
            {showMnStandardsLink ? (
              <Link
                href={`https://education.mn.gov/MDE/dse/stds/${MnStateStandardsKey[category]}/`}
                target="_blank"
              >
                <strong>{ContentSubjectDescriptions[category]}</strong>
              </Link>
            ) : (
              <strong>{ContentSubjectDescriptions[category]}</strong>
            )}
          </Typography>
          <ul className={styles.list}>
            {(list as string[]).map((item, index) => (
              <li key={index}>
                <Typography variant="body2">{item}</Typography>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </>
  );
};

export default SubjectBasedLists;
